function getQueryParams() {
    const queryParams = new URLSearchParams(window.location.search.substring(1));
    return Object.fromEntries(queryParams);
}
